var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 373,
    viewBox: "0 0 256 373",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 256L23.2727 93.0909L116.364 0L232.727 116.364L162.909 186.182L256 279.273L116.364 372.364L0 256Z",
    fill: "#00D1B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulma);
export default __webpack_public_path__ + "static/media/bulma.5910d4416e077262d0264109649ab214.svg";
export { ForwardRef as ReactComponent };